module.exports = __webpack_public_path__ + "img/43.f6a639eb.jpg";